export default "/_next/static/chunks/fonts/IBM Plex Sans SemiBold-f234c3997b959c96904ca1d8b5a049e1.ttf";